/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../common/404';
import Generate_Token from './../../modules/Generate-Token';
import Counsellor_Start from './../../modules/Counselling/Start';
import Counsellor_Profile from '../Counselling/profile';
import Finanical_Counselling from '../Counselling/Counselling-Forms/Finanical-Counselling';
import Insurance_Counselling from '../Counselling/Counselling-Forms/Insurance-Counselling';
import Manager_Dashboard from '../Dashboard';
import Report_Finanical_Counselling from '../Manager/Report';
import Add_User from '../Manager/User/Add-User';
import Add_Role from '../Manager/Role/Add-Role';
import Role_List from '../Manager/Role/Role-List';
import Idle_TAT_Report from '../Reports/Idle-TAT-Report';
import TAT_Report from '../Reports/Tat-Report';
import User_List from '../Manager/User/User-List';
import Privilege_Create from '../Manager/Privilege/Privilege-Create';
import User_Doctor_Map from '../Manager/User/User-to-Doctor-Map';
import User_Details from '../Manager/User/User-Details';
import Planned_Admission_Report from '../Reports/Planned_Admission_Report';
import Estimate_Variance_Report from '../Reports/Estimate_Variance_Report';
import Bill_Header_Wise from '../Reports/Bill-Header-Wise';
import ReCounselling_Done from './ReCounselling-Done';
import Bill_TAT_Report from './Bill-TAT-Report';
import Due_worklist from './Due-worklist';
import Documents_Report from './Documents';
import Query_Report from './Query-Reports';
class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        // console.log(this.props);
    }
    renderbodyLayer() {
        const { slug } = this.props.match.params
        const { menuList } = this.props;
        let obj = null;
        menuList.map(data => {
            var subData = data
                .submenu
                .find(o => o.route === slug);
            if (subData != undefined) {
                obj = subData;
            }
        })
        var page = null;
        if (obj !== undefined) {
            switch (slug) {
                case 'tat-reports':
                case 'recounselling-report':
                case 'planned-admission-report':
                case 'estimate-variance-report':
                case 'idle-reports':
                case 'bill-tat-report':
                case 'remarks-report':  
                case 'log-report':      
                    page = <TAT_Report {...this.props} menuList={menuList} />;
                    break;
                // case 'idle-reports':
                //     page = <Idle_TAT_Report {...this.props} menuList={menuList} />;
                //     break;
                // case 'planned-admission-report':
                //     page = <Planned_Admission_Report {...this.props} menuList={menuList} />;
                //     break;
                // case 'recounselling-report':
                //     page = <ReCounselling_Done {...this.props} menuList={menuList} />;
                //     break;
                // case 'estimate-variance-report':
                //     page = <Estimate_Variance_Report {...this.props} menuList={menuList} />;
                //     break;
                case 'bill-header-wise-report':
                    page = <Bill_Header_Wise {...this.props} menuList={menuList} />;
                    break;
                // case 'due-worklist':
                //     page = <Due_worklist {...this.props} menuList={menuList} />;
                //     break;
                case 'documents-report':
                    page = <Documents_Report {...this.props} menuList={menuList} />;
                    break;
                // case 'bill-tat-report':
                //     page = <Bill_TAT_Report {...this.props} menuList={menuList} />;
                //     break;
                case 'query-report':
                    page = <Query_Report {...this.props} menuList={menuList} />
                    break;
                default:
                    let submenu = null;
                    if (menuList[0]['submenu'].length !== 0) {
                        submenu = menuList[0]['submenu'][0]['route']
                    }
                    if (submenu !== null) {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}/${submenu}`);
                    } else {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}`);
                    }
                    //page = <div></div>;
                    // page = <Generate_Token {...this.props} menuList={menuList}/>
                    // page = <Counsellor_Start {...this.props} menuList={menuList}/>                   
                    // page = <Counsellor_Token {...this.props} menuList={menuList}/>
                    // page = <Finanical_Counselling {...this.props} menuList={menuList}/>
                    // page = <Insurance_Counselling {...this.props} menuList={menuList}/>
                    // page = <Track_Bills {...this.props} menuList={menuList}/>
                    //page = <Bill_details {...this.props} menuList={menuList}/>
                    // page = <Counsellor_Profile {...this.props} menuList={menuList}/>
                    // page = <Manager_Dashboard {...this.props} menuList={menuList}/>
                    // page = <Report_Finanical_Counselling {...this.props} menuList={menuList}/>                  
                    // page = <Bill_Header_Wise {...this.props} menuList={menuList}/>
                    // page = <Add_User {...this.props} menuList={menuList}/>
                    // page = <Add_Role {...this.props} menuList={menuList}/>
                    // page = <Role_List {...this.props} menuList={menuList}/>
                    // page = <Idle_TAT_Report {...this.props} menuList={menuList}/>
                    // page = <TAT_Report {...this.props} menuList={menuList}/>
                    // page = <User_List {...this.props} menuList={menuList}/>
                    // page = <Privilege_Create {...this.props} menuList={menuList}/>
                    // page = <User_Doctor_Map {...this.props} menuList={menuList}/>
                    // page = <User_Details {...this.props} menuList={menuList}/>
                    break;
            }
        } else {
            page = <Accesspage></Accesspage>;
        }

        return page;
    }
    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Reports;
